import {
  DEFAULT_PAGE_NUMBER,
  EMPTY_STRING,
  FILTER_NAMES as COMMON_FILTER_NAMES,
  ORDER,
  SORT_FIELDS as COMMON_SORT_FIELDS
} from '../base.js'
import {FILTERS_GROUPS_IDS} from '../common/filtersGroups.js'
import {VEHICLE_STATE_IDS} from './subscription.js'

/**
 * @exports AD_STATUS
 */
export const AD_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PREVIEW: 'preview'
}

export const RELATED_AD_CONTEXT = {
  PRIVATE_DETAIL: 'private-detail',
  PROFESSIONAL_DETAIL_TYPE_DISCOVER: 'professional-detail-type-discover',
  PROFESSIONAL_DETAIL_TYPE_START: 'professional-detail-type-start'
}

export const SUBSCRIPTION_AD_CONTEXT = {
  COMMITMENT: 'commitment',
  ALLOWANCE: 'allowance'
}

export const ADS_LIST_SIZE = 20

export const HAS_NEW_VEHICLE_ADS_LIST_ENABLED = false

export const HAS_SUBSCRIPTION_ADS_LIST_ENABLED = false

export const SHOW_DEALER_RATING = false

export const HAS_ADS_LIST_MODEL_DETAILS_CAROUSEL_ENABLED = false

export const DEFAULT_TAB = 1

export const DEFAULT_FILTER_VALUE = null
export const DEFAULT_BOOL_FILTER_VALUE = false
export const DEFAULT_OPTION_VALUE = 0

export const DEFAULT_KMS_MIN = 0
export const DEFAULT_KMS_MAX = 200000

export const DEFAULT_YEAR = 0
export const DEFAULT_YEAR_MIN = 1970
export const DEFAULT_YEAR_MAX = new Date().getFullYear()

export const DEFAULT_PRICE = 0
export const LAST_PRICE = 999999

export const DEFAULT_MODEL = {
  id: DEFAULT_OPTION_VALUE,
  name: EMPTY_STRING
}

export const DEFAULT_COLOR = DEFAULT_OPTION_VALUE

export const DEFAULT_COLORS = []

export const PROVINCES_WITH_POSTAL_CODE = [28]

export const LAST_SEARCH_ITEMS_COUNT = 6

export const DEFAULT_TEXT = EMPTY_STRING

export const DEFAULT_SEARCH_TEXT = undefined

export const DEFAULT_PROVINCE = DEFAULT_OPTION_VALUE
export const DEFAULT_PROVINCES = []

export const DEFAULT_EQUIPMENT = DEFAULT_OPTION_VALUE
export const DEFAULT_EQUIPMENTS = []

export const DEFAULT_FUEL_TYPE = DEFAULT_OPTION_VALUE
export const DEFAULT_FUEL_TYPES = []

export const DEFAULT_BODY_TYPE = DEFAULT_OPTION_VALUE
export const DEFAULT_BODY_TYPES = []

export const DEFAULT_SELLER_TYPE = DEFAULT_OPTION_VALUE

export const DEFAULT_LITRES = DEFAULT_OPTION_VALUE

export const DEFAULT_HP = DEFAULT_OPTION_VALUE
export const DEFAULT_HP_MIN = 0

export const DEFAULT_LOCATION_MAX_RADIO = 300
export const DEFAULT_LOCATION_MIN_RADIO = 10
export const DEFAULT_LOCATION_TEXT = EMPTY_STRING

export const DEFAULT_VERSION = EMPTY_STRING

export const DEFAULT_VEHICLE = {
  [COMMON_FILTER_NAMES.MAKE]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MODEL]: DEFAULT_MODEL,
  [COMMON_FILTER_NAMES.VERSION]: DEFAULT_VERSION
}
export const DEFAULT_EXCLUDED_VEHICLES = []
export const DEFAULT_VEHICLES = []

/**
 * @exports URL_PATTERN
 */
export const URL_PATTERN =
  '?MakeId={MAKE_ID}&ModelId={MODEL_ID}&PrvId={PRV_ID}&FuelTypeId={FUEL_TYPE_ID}&MaxKms={MAX_KMS}&MinKms={MIN_KMS}&MaxYear={MAX_YEAR}&MinYear={MIN_YEAR}&MaxPrice={MAX_PRICE}&text={TEXT}'

export const URL_VEHICLE_CARD_FALLBACK = '/detail'

/**
 * @exports litres
 */
export const litres = [50, 125, 250, 500, 600, 750, 1000, 1200]

/**
 * @exports prices
 */
export const prices = [500, 1000, 2000, 4000, 6000, 8000, 10000, 15000]

/**
 * @exports priceChipSeeds
 */
export const priceChipSeeds = [500, 1000, 2000, 4000]

/**
 * @exports priceToChipSeeds
 */
export const priceToChipSeeds = [1000, 2000, 4000, 6000]

/**
 * @exports kmsChipSeeds
 */
export const kmsChipSeeds = [2500, 5000, 10000, 20000]

/**
 * @exports kmsToChipSeeds
 */
export const kmsToChipSeeds = [10000, 15000, 20000, 25000]

/**
 * @exports kms
 */
export const kms = [
  2500, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000, 65000, 70000, 75000, 80000,
  85000, 90000, 95000, 100000, 120000, 140000, 160000, 180000
]

export const ENVIRONMENTAL_LABELS_0_ID = '0'
export const ENVIRONMENTAL_LABELS_ECO_ID = 'ECO'
export const ENVIRONMENTAL_LABELS_B_ID = 'B'
export const ENVIRONMENTAL_LABELS_C_ID = 'C'

export const environmentalLabels = [
  {
    id: ENVIRONMENTAL_LABELS_0_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.0'
  },
  {
    id: ENVIRONMENTAL_LABELS_ECO_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.ECO'
  },
  {
    id: ENVIRONMENTAL_LABELS_C_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.C'
  },
  {
    id: ENVIRONMENTAL_LABELS_B_ID,
    label: 'COMMON.ENVIRONMENTAL_LABELS.B'
  }
]

export const ENVIRONMENTAL_LABEL_ICONS = {
  0: 'images/common/eco-label-icons/0.svg',
  ECO: 'images/common/eco-label-icons/eco.svg',
  B: 'images/common/eco-label-icons/b.svg',
  C: 'images/common/eco-label-icons/c.svg'
}

export const hp = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 200]
export const kwFromHp = {
  5: 3.7,
  10: 7.5,
  15: 11.2,
  20: 14.9,
  25: 18.6,
  30: 22.4,
  35: 26.1,
  40: 29.8,
  45: 33.5,
  50: 37.3,
  55: 41,
  60: 44.7,
  65: 48.4,
  70: 52.1,
  75: 55.9,
  80: 59.6,
  85: 63.3,
  90: 67,
  95: 70.8,
  100: 74.5,
  200: 149
}
export const equipments = []

export const FUEL_TYPE_DIESEL_ID = 1
export const FUEL_TYPE_GASOLINE_ID = 2
export const FUEL_TYPE_ELECTRIC_ID = 3
export const FUEL_TYPE_HYBRID_ID = 4
export const FUEL_TYPE_HYBRID_PLUG_IN_ID = 5
export const FUEL_TYPE_GLP_ID = 6
export const FUEL_TYPE_CNG_ID = 7
export const FUEL_TYPE_OTHER_ID = 8

/**
 * @exports fuelTypes
 */
export const fuelTypes = [
  {
    id: FUEL_TYPE_GASOLINE_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_GASOLINE',
    slug: 'gasolina'
  },
  {
    id: FUEL_TYPE_ELECTRIC_ID,
    label: 'SEARCH_BOX_SELECT_FUEL_TYPE_ELECTRIC',
    slug: 'electrico'
  }
]

/**
 * @exports taxTypes
 */
export const taxTypes = [
  {
    id: 1,
    label: 'IVA'
  },
  {
    id: 2,
    label: 'IGIC'
  }
]

export const COLORS_ID = {
  YELLOW: '1',
  BLUE: '2',
  BEIGE: '3',
  WHITE: '4',
  GARNET: '5',
  GRAY: '6',
  BROWN: '7',
  ORANGE: '8',
  BLACK: '9',
  RED: '10',
  PINK: '11',
  GREEN: '12',
  PURPLE: '13'
}

export const colors = [
  {id: COLORS_ID.YELLOW, label: 'COMMON.COLOR_YELLOW'},
  {id: COLORS_ID.BLUE, label: 'COMMON.COLOR_BLUE'},
  {id: COLORS_ID.BEIGE, label: 'COMMON.COLOR_BEIGE'},
  {id: COLORS_ID.WHITE, label: 'COMMON.COLOR_WHITE'},
  {id: COLORS_ID.GARNET, label: 'COMMON.COLOR_GARNET'},
  {id: COLORS_ID.GRAY, label: 'COMMON.COLOR_GRAY'},
  {id: COLORS_ID.BROWN, label: 'COMMON.COLOR_BROWN'},
  {id: COLORS_ID.ORANGE, label: 'COMMON.COLOR_ORANGE'},
  {id: COLORS_ID.BLACK, label: 'COMMON.COLOR_BLACK'},
  {id: COLORS_ID.RED, label: 'COMMON.COLOR_RED'},
  {id: COLORS_ID.PINK, label: 'COMMON.COLOR_PINK'},
  {id: COLORS_ID.GREEN, label: 'COMMON.COLOR_GREEN'},
  {id: COLORS_ID.PURPLE, label: 'COMMON.COLOR_PURPLE'}
]

export const BODY_TYPE_ID_MOPED = 3010
export const BODY_TYPE_ID_MOPED_2 = 12
export const BODY_TYPE_ID_MOPED_GEARS = 15
export const BODY_TYPE_ID_SCOOTER_50 = 16
export const BODY_TYPE_ID_SCOOTER = 3020
export const BODY_TYPE_ID_SCOOTER_125 = 10
export const BODY_TYPE_ID_SCOOTER_125PLUS = 11
export const BODY_TYPE_ID_ROAD = 3030
export const BODY_TYPE_ID_ROAD_CUSTOM = 2
export const BODY_TYPE_ID_ROAD_NAKED = 14
export const BODY_TYPE_ID_ROAD_SPORT = 5
export const BODY_TYPE_ID_ROAD_SUPERMOTARD = 6
export const BODY_TYPE_ID_ROAD_TOURISM = 9
export const BODY_TYPE_ID_OFFROAD = 3040
export const BODY_TYPE_ID_OFFROAD_CROSS = 1
export const BODY_TYPE_ID_OFFROAD_ENDURO = 3
export const BODY_TYPE_ID_OFFROAD_KIDS = 4
export const BODY_TYPE_ID_OFFROAD_TRAIL = 7
export const BODY_TYPE_ID_OFFROAD_TRIAL = 8

/**
 * @exports bodyTypes
 */
export const bodyTypes = [
  {
    id: BODY_TYPE_ID_MOPED,
    label: 'BODY_TYPE_MOPED'
  },
  {
    id: BODY_TYPE_ID_MOPED_2,
    label: 'BODY_TYPE_MOPED'
  },
  {
    id: BODY_TYPE_ID_MOPED_GEARS,
    label: 'BODY_TYPE_MOPED_GEARS'
  },
  {
    id: BODY_TYPE_ID_SCOOTER_50,
    label: 'BODY_TYPE_SCOOTER_50'
  },
  {
    id: BODY_TYPE_ID_SCOOTER,
    label: 'BODY_TYPE_SCOOTER'
  },
  {
    id: BODY_TYPE_ID_SCOOTER_125,
    label: 'BODY_TYPE_SCOOTER_125'
  },
  {
    id: BODY_TYPE_ID_SCOOTER_125PLUS,
    label: 'BODY_TYPE_SCOOTER_125PLUS'
  },
  {
    id: BODY_TYPE_ID_ROAD,
    label: 'BODY_TYPE_ROAD'
  },
  {
    id: BODY_TYPE_ID_ROAD_CUSTOM,
    label: 'BODY_TYPE_ROAD_CUSTOM'
  },
  {
    id: BODY_TYPE_ID_ROAD_NAKED,
    label: 'BODY_TYPE_ROAD_NAKED'
  },
  {
    id: BODY_TYPE_ID_ROAD_SPORT,
    label: 'BODY_TYPE_ROAD_SPORT'
  },
  {
    id: BODY_TYPE_ID_ROAD_SUPERMOTARD,
    label: 'BODY_TYPE_ROAD_SUPERMOTARD'
  },
  {
    id: BODY_TYPE_ID_ROAD_TOURISM,
    label: 'BODY_TYPE_ROAD_TOURISM'
  },
  {
    id: BODY_TYPE_ID_OFFROAD,
    label: 'BODY_TYPE_OFFROAD'
  },
  {
    id: BODY_TYPE_ID_OFFROAD_CROSS,
    label: 'BODY_TYPE_OFFROAD_CROSS'
  },
  {
    id: BODY_TYPE_ID_OFFROAD_ENDURO,
    label: 'BODY_TYPE_OFFROAD_ENDURO'
  },
  {
    id: BODY_TYPE_ID_OFFROAD_KIDS,
    label: 'BODY_TYPE_OFFROAD_KIDS'
  },
  {
    id: BODY_TYPE_ID_OFFROAD_TRAIL,
    label: 'BODY_TYPE_OFFROAD_TRAIL'
  },
  {
    id: BODY_TYPE_ID_OFFROAD_TRIAL,
    label: 'BODY_TYPE_OFFROAD_TRIAL'
  }
]

export const bodyTypesImages = {}

export const TRANNSMISSION_TYPE_ID_AUTOMATIC = 1
export const TRANNSMISSION_TYPE_ID_MANUAL = 2

/**
 * @exports SUGGEST_DEBOUNCE_TIME (300ms)
 */
export const SUGGEST_DEBOUNCE_TIME = 300

/**
 * @exports DEFAULT_RELATED_ADS_COUNT
 */
export const DEFAULT_RELATED_ADS_COUNT = 4

/**
 * @exports NUMBER_FREE_ADS
 */
export const NUMBER_FREE_ADS = 2

/**
 * @exports SHOW_CUSTOM_MONTHLY_FEE
 */
export const SHOW_CUSTOM_MONTHLY_FEE = true

/**
 * @exports SHOW_WARRANTY
 */
export const SHOW_WARRANTY = false

/**
 * @exports SHOW_TAXES
 */
export const SHOW_TAXES = false

/**
 * @exports SHOW_WARRANTY_FREE_TEXT
 */
export const SHOW_WARRANTY_FREE_TEXT = true

/**
 * @exports FILTER_NAMES
 */
export const FILTER_NAMES = COMMON_FILTER_NAMES

/**
 * @exports MOTOS_CATEGORY1_ID
 */
export const MOTOS_CATEGORY1_ID = 3000

/**
 * @exports QUADS_CATEGORY1_ID
 */
export const QUADS_CATEGORY1_ID = 3100

/**
 * @exports BUGGIES_CATEGORY1_ID
 */
export const BUGGIES_CATEGORY1_ID = 3500

/**
 * @exports MINIMOTOS_CATEGORY1_ID
 */
export const MINIMOTOS_CATEGORY1_ID = 3600

/**
 * @exports CLASSICS_CATEGORY1_ID
 */
export const CLASSICS_CATEGORY1_ID = 3200

/**
 * @exports DEFAULT_CATEGORY1_ID
 */
export const DEFAULT_CATEGORY1_ID = MOTOS_CATEGORY1_ID

/**
 *
 * @exports DEFAULT_CATEGORIES
 */
export const DEFAULT_CATEGORIES = {CATEGORY_1IDS: [DEFAULT_CATEGORY1_ID], CATEGORY_2IDS: []}

/**
 * @exports DEFAULT_OFFER_TYPE_ID
 */
export const OFFER_TYPE_SECOND_HAND = 0
export const OFFER_TYPE_NEW = 1
export const OFFER_TYPE_KM0 = 2
export const OFFER_TYPE_SUBSTITUTION = 3
export const OFFER_TYPE_MANAGEMENT = 4
export const OFFER_TYPE_DEMONSTRATION = 5
export const OFFER_TYPE_RENTAL = 7
export const OFFER_TYPE_PRE_OWNED = 8
export const OFFER_TYPE_SUBSCRIPTION = 10
export const DEFAULT_OFFER_TYPE_ID = OFFER_TYPE_SECOND_HAND
export const UNSELECTED_OFFER_TYPE = -1
export const ALL_OFFER_TYPES = [OFFER_TYPE_SECOND_HAND, OFFER_TYPE_NEW]
export const ALL_OFFER_TYPES_IN_SECOND_HAND = [
  OFFER_TYPE_SECOND_HAND,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]
export const ALL_OFFER_TYPES_IN_KM0 = [
  OFFER_TYPE_NEW,
  OFFER_TYPE_KM0,
  OFFER_TYPE_SUBSTITUTION,
  OFFER_TYPE_MANAGEMENT,
  OFFER_TYPE_DEMONSTRATION
]
export const SUBSCRIPTION_FILTERS_CONF = [FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE]

export const DEFAULT_CITY = EMPTY_STRING

/**
 * @exports ADS_SEARCH_TOPBAR_FILTERS_MAP
 */
export const ADS_SEARCH_TOPBAR_FILTERS_MAP = {
  [MOTOS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.BODY_TYPE_CATEGORY,
      FILTER_NAMES.KMS
    ],
    [
      FILTER_NAMES.MAKE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.BODY_TYPE_CATEGORY,
      FILTER_NAMES.LITRES
    ]
  ],
  [QUADS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.KMS
    ],
    [FILTER_NAMES.MAKE, FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.PRICE, FILTER_NAMES.LITRES]
  ],
  [BUGGIES_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.KMS
    ],
    [FILTER_NAMES.MAKE, FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.PRICE, FILTER_NAMES.LITRES]
  ],
  [MINIMOTOS_CATEGORY1_ID]: [[FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID], [FILTER_NAMES.PRICE]],
  [CLASSICS_CATEGORY1_ID]: [[FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.PRICE]]
}

/**
 * @exports ADS_FILTERS_MAP
 */
export const ADS_FILTERS_MAP = {
  [MOTOS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.KMS,
      FILTER_NAMES.BODY_TYPE_CATEGORY,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.HP,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PRICE,
      FILTER_NAMES.HAS_PRICE_DROP,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.BODY_TYPE_CATEGORY,
      FILTER_NAMES.FUEL_TYPE,
      FILTER_NAMES.HP,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [QUADS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.KMS,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [BUGGIES_CATEGORY1_ID]: [
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.YEAR,
      FILTER_NAMES.KMS,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.MAKE,
      FILTER_NAMES.MODEL,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.LITRES,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [MINIMOTOS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.SEARCH_TEXT,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.HAS_PHOTO
    ],
    [
      FILTER_NAMES.SEARCH_TEXT,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.HAS_PHOTO
    ]
  ],
  [CLASSICS_CATEGORY1_ID]: [
    [
      FILTER_NAMES.SEARCH_TEXT,
      FILTER_NAMES.PRICE,
      FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
      FILTER_NAMES.ONLY_PENINSULA,
      FILTER_NAMES.SELLER_TYPE,
      FILTER_NAMES.HAS_PHOTO
    ]
  ]
}

export const ALL_OFFER_TYPES_ADS_FILTERS_MAP = [
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.HAS_PRICE_DROP,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.ONLY_PENINSULA,
  FILTER_NAMES.SELLER_TYPE,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.BODY_TYPE_CATEGORY,
  FILTER_NAMES.FUEL_TYPE,
  FILTER_NAMES.HP,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.HAS_PHOTO
]

export const DEFAULT_FILTERS_MAP = ALL_OFFER_TYPES_ADS_FILTERS_MAP

export const DEFAULT_SEARCH_TOPBAR_FILTERS_MAP = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.PRICE,
  FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.KMS,
  FILTER_NAMES.BODY_TYPE_CATEGORY,
  FILTER_NAMES.LITRES
]

/**
 * @exports TECHNICAL_DETAILS_SEARCH_FILTERS_MAP
 */
export const TECHNICAL_DETAILS_SEARCH_FILTERS_MAP = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL_VERSION,
  FILTER_NAMES.BODY_TYPE_CATEGORY,
  FILTER_NAMES.PRICE,
  FILTER_NAMES.YEAR,
  FILTER_NAMES.LITRES,
  FILTER_NAMES.FUEL_TYPE
]

/**
 * @exports ADS_SEARCH_LITE_FILTERS_MAP
 */
export const ADS_SEARCH_LITE_FILTERS_MAP = [
  FILTER_NAMES.OFFER_TYPE,
  FILTER_NAMES.MAKE,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.PRICE
]

export const CATEGORY2_ID_MOTORCYCLE = 3010
export const CATEGORY2_ID_SCOOTER = 3020
export const CATEGORY2_ID_ROAD = 3030
export const CATEGORY2_ID_OFFROAD = 3040
export const CATEGORY2_ID_MOTO_PARTS = 3310
export const CATEGORY2_ID_MOTO_CLOTHING = 3320
export const CATEGORY2_ID_WHEELS = 3330
export const CATEGORY2_ID_TRUNK = 3340
export const CATEGORY2_ID_MOTOS_OTHERS = 3350

export const MOTOS_CATEGORY2_ID = [
  {
    label: 'CATEGORY_2_DEFAULT',
    id: 0
  },
  {
    label: 'BODY_TYPE_MOPED',
    id: CATEGORY2_ID_MOTORCYCLE
  },
  {
    label: 'BODY_TYPE_SCOOTER',
    id: CATEGORY2_ID_SCOOTER
  },
  {
    label: 'BODY_TYPE_ROAD',
    id: CATEGORY2_ID_ROAD
  },
  {
    label: 'BODY_TYPE_OFFROAD',
    id: CATEGORY2_ID_OFFROAD
  }
]

export const CATEGORY2_MAP = {
  [MOTOS_CATEGORY1_ID]: MOTOS_CATEGORY2_ID
}

/**
 * @exports BODY_TYPE_CATEGORY
 */
export const BODY_TYPE_CATEGORY = {
  MOTORCYCLE: CATEGORY2_ID_MOTORCYCLE,
  SCOOTER: CATEGORY2_ID_SCOOTER,
  ROAD: CATEGORY2_ID_ROAD,
  OFFROAD: CATEGORY2_ID_OFFROAD
}

/**
 * @exports TAGS_VISIBILITY
 */
export const TAGS_VISIBILITY = {
  FINANCED: true,
  MULTI_PROVINCE: false,
  URGENT: true
}

export const SHOW_HIGHLIGHTED_ADS = false

export const SORT_BY_PRICE = {
  [COMMON_SORT_FIELDS.PRICE]: {
    queryParam: 'Price',
    label: {
      [ORDER.ASC]: 'SORT_PRICE_CASH_ASC',
      [ORDER.DESC]: 'SORT_PRICE_CASH_DESC'
    }
  }
}

export const SORT_BY_KM = {
  [COMMON_SORT_FIELDS.KM]: {
    queryParam: 'Kilometers',
    label: {
      [ORDER.ASC]: 'SORT_KMS_COCHES_ASC',
      [ORDER.DESC]: 'SORT_KMS_COCHES_DESC'
    }
  }
}

export const SORT_BY_YEAR = {
  [COMMON_SORT_FIELDS.YEAR]: {
    queryParam: 'Year',
    label: {
      [ORDER.ASC]: 'SORT_YEAR_COCHES_ASC',
      [ORDER.DESC]: 'SORT_YEAR_COCHES_DESC'
    }
  }
}

export const SORT_BY_RELEVANCE = {
  [COMMON_SORT_FIELDS.RELEVANCE]: {
    queryParam: 'SortDate',
    label: {
      [ORDER.DESC]: 'SORT_DATE_RELEVANCE_DESC'
    }
  }
}

/**
 * @exports SORT
 */
export const SORT = {
  ...SORT_BY_RELEVANCE,
  ...SORT_BY_PRICE,
  ...SORT_BY_KM,
  ...SORT_BY_YEAR
}

const DEFAULT_SORT = SORT

export const SORT_BY_CATEGORY1_ID = {
  [MOTOS_CATEGORY1_ID]: DEFAULT_SORT,
  [QUADS_CATEGORY1_ID]: DEFAULT_SORT,
  [BUGGIES_CATEGORY1_ID]: DEFAULT_SORT,
  [MINIMOTOS_CATEGORY1_ID]: DEFAULT_SORT,
  [CLASSICS_CATEGORY1_ID]: DEFAULT_SORT
}

export const offerTypes = [
  {
    id: OFFER_TYPE_SECOND_HAND,
    label: 'COMMON_OPPORTUNITY'
  },
  {
    id: OFFER_TYPE_NEW,
    label: 'COMMON.OFFER_TYPE.NEW'
  }
]

export const adsListSearchOfferTypes = [
  {
    id: OFFER_TYPE_SECOND_HAND,
    label: 'COMMON_OPPORTUNITY'
  },
  {
    id: OFFER_TYPE_NEW,
    label: 'COMMON.OFFER_TYPE.NEW'
  }
]

export const vehicleStates = [
  {
    id: VEHICLE_STATE_IDS.NEW,
    label: 'COMMON.OFFER_TYPE.NEW'
  },
  {
    id: VEHICLE_STATE_IDS.USED,
    label: 'COMMON_OPPORTUNITY'
  }
]

export const DEFAULT_OFFER_TYPE = -1

/**
 * @exports TECHNICAL_DETAILS_SORT
 */
export const TECHNICAL_DETAILS_SORT = {
  [COMMON_SORT_FIELDS.TITLE]: {
    queryParam: 'Title',
    label: {
      [ORDER.ASC]: 'SORT_TITLE_ASC'
    }
  },
  [COMMON_SORT_FIELDS.YEAR]: {
    queryParam: 'Year',
    label: {
      [ORDER.ASC]: 'SORT_YEAR_MOTOS_ASC',
      [ORDER.DESC]: 'SORT_YEAR_MOTOS_DESC'
    }
  },
  [COMMON_SORT_FIELDS.CC]: {
    queryParam: 'cc',
    label: {
      [ORDER.ASC]: 'SORT_CC_ASC',
      [ORDER.DESC]: 'SORT_CC_DESC'
    }
  }
}

/**
 * @exports CREATE_ALERT_QUERY_PARAM
 */
export const CREATE_ALERT_QUERY_PARAM = 'createAlert'

export const PHONE_CALL_QUERY_PARAM = 'phoneCall'

/**
 * @exports DEFAULT_FILTERS
 */
export const DEFAULT_FILTERS = {
  [COMMON_FILTER_NAMES.CATEGORY_2]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MAKE]: DEFAULT_FILTER_VALUE,
  [COMMON_FILTER_NAMES.MODEL]: DEFAULT_MODEL,
  [COMMON_FILTER_NAMES.FUEL_TYPE]: DEFAULT_FUEL_TYPES,
  [COMMON_FILTER_NAMES.BODY_TYPE]: DEFAULT_BODY_TYPES,
  [COMMON_FILTER_NAMES.PROVINCE]: DEFAULT_PROVINCES,
  [COMMON_FILTER_NAMES.ONLY_PENINSULA]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.PRICE]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.LITRES]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.YEAR]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.KMS]: {
    from: DEFAULT_FILTER_VALUE,
    to: DEFAULT_FILTER_VALUE
  },
  [COMMON_FILTER_NAMES.SELLER_TYPE]: DEFAULT_SELLER_TYPE,
  [COMMON_FILTER_NAMES.VERSION]: DEFAULT_VERSION,
  [COMMON_FILTER_NAMES.SEARCH_TEXT]: DEFAULT_SEARCH_TEXT,
  [COMMON_FILTER_NAMES.HAS_PHOTO]: DEFAULT_BOOL_FILTER_VALUE,
  [COMMON_FILTER_NAMES.EXCLUDED_VEHICLES]: DEFAULT_EXCLUDED_VEHICLES,
  [COMMON_FILTER_NAMES.VEHICLES]: DEFAULT_VEHICLES,
  [COMMON_FILTER_NAMES.OFFER_TYPE]: UNSELECTED_OFFER_TYPE
}

export const DEFAULT_SEARCH = {
  ...DEFAULT_FILTERS,
  categoryId: DEFAULT_CATEGORY1_ID,
  offerTypeId: DEFAULT_OFFER_TYPE_ID,
  page: DEFAULT_PAGE_NUMBER,
  [COMMON_FILTER_NAMES.SORT_BY]: COMMON_SORT_FIELDS.RELEVANCE,
  sortOrder: ORDER.DESC
}

export const UNIQUE_LISTING_DEFAULT_SEARCH = {
  ...DEFAULT_SEARCH,
  offerTypeId: UNSELECTED_OFFER_TYPE
}

export const RENTING_DEFAULT_SEARCH = {}

export const SHOW_MULTI_PROVINCE_INFO_ADS = false

export const STATISTICS_TYPES = {
  averagePrice: 'AVERAGE_PRICE',
  averageKm: 'AVERAGE_KM',
  averageConsumption: 'AVERAGE_CONSUMPTION',
  popularYear: 'POPULAR_YEAR',
  popularFuelType: 'POPULAR_FUEL_TYPE',
  popularColor: 'POPULAR_COLOR'
}

export const IS_STATS_DATA_ENABLED = true

export const DEFAULT_FILTERS_PLACEHOLDERS = {
  [FILTER_NAMES.BODY_TYPE_CATEGORY]: 'FORM_BODY_TYPE_MOTOS_LABEL',
  [FILTER_NAMES.FUEL_TYPE]: 'COMMON.FUEL',
  [FILTER_NAMES.KMS]: 'COMMON.KMS',
  [FILTER_NAMES.LITRES]: 'COMMON_LITRES',
  [FILTER_NAMES.LOCATION]: 'COMMON.LOCATION',
  [FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID]: 'COMMON.LOCATION',
  [FILTER_NAMES.MAKE]: 'COMMON.MAKE',
  [FILTER_NAMES.MODEL]: 'COMMON.PLURALS.MODEL',
  [FILTER_NAMES.PRICE]: 'COMMON.PRICE',
  [FILTER_NAMES.VEHICLES]: 'COMMON.MAKE_MODEL',
  [FILTER_NAMES.YEAR]: 'COMMON.YEAR',
  [FILTER_NAMES.PROVINCE]: 'COMMON.PLURALS.PROVINCE'
}

export const DEFAULT_FILTERS_LABELS = {
  [FILTER_NAMES.BODY_TYPE_CATEGORY]: 'FORM_BODY_TYPE_MOTOS_LABEL',
  [FILTER_NAMES.FUEL_TYPE]: 'COMMON.FUEL_TYPE',
  [FILTER_NAMES.KMS]: 'COMMON.MILEAGE',
  [FILTER_NAMES.LITRES]: 'COMMON_LITRES',
  [FILTER_NAMES.MAKE]: 'COMMON.MAKE',
  [FILTER_NAMES.MODEL]: 'COMMON.PLURALS.MODEL',
  [FILTER_NAMES.VEHICLES]: 'COMMON.MAKE_MODEL',
  [FILTER_NAMES.YEAR]: 'COMMON.PRODUCTION_YEAR',
  [FILTER_NAMES.PROVINCE]: 'COMMON.PLURALS.PROVINCE'
}

export const FIELDS_WITH_SEARCH_BAR = [
  FILTER_NAMES.MAKE,
  FILTER_NAMES.MODEL,
  FILTER_NAMES.PROVINCE,
  FILTER_NAMES.EQUIPMENTS,
  FILTER_NAMES.COLOR
]

export const HAS_RECOMMENDER = false

export const RECOMMENDATIONS_TARGETS = {
  DEALER_NO_RESPONSE: 'dealerNoResponse'
}

export const ENABLED_COMPARATOR_CATEGORY_IDS = [MOTOS_CATEGORY1_ID]
